<template>
  <form @submit.prevent="submitForm">
    <div class="row">
      <div class="col-md-6">
        <FormField id="Clave" label="Clave" type="text" v-model="formData.Clave" :required="true" :maxlength="50" :disabled="isEditing" helpText="Código único del grupo" />
      </div>
      <div class="col-md-6">
        <FormField id="EmpresaId" label="ID Empresa" type="number" v-model="formData.EmpresaId" :required="true" :disabled="true" helpText="Identificador de la empresa" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <FormField id="Nombre" label="Nombre" type="text" v-model="formData.Nombre" :required="true" :maxlength="150" helpText="Nombre del grupo" />
      </div>
      <div class="col-md-4">
        <FormField id="ClaveErp" label="Clave ERP" type="text" v-model="formData.ClaveErp" :maxlength="50" helpText="Clave en el ERP" />
      </div>
    </div>


    <div class="row">
      <div class="col-md-6">
        <FormField id="EsActivo" label="Estado" type="checkbox" v-model="formData.EsActivo" checkboxLabel="Grupo activo" />
      </div>
    </div>

    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';

export default {
  name: 'CatGrupoEmpleadoForm',
  components: { FormField },
  props: {
    grupo: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: 1,
        Nombre: '',
        ClaveErp: '',
        EsActivo: true
      })
    },
    isEditing: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data() { return { formData: { ...this.grupo } }; },
  watch: {
    grupo: {
      handler(newValue) { this.formData = { ...newValue }; },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      const dataToSubmit = { ...this.formData };
      this.$emit('submit', dataToSubmit);
    }
  }
}
</script>

<style scoped>
</style>


